import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

interface Params {
    iss: string;
    code: string;
    scope: string;
    authuser: number;
    prompt: string;
}

declare module '@stackflow/config' {
    interface Register {
        SignInWithGoogleActivity: Params;
    }
}

const SignInWithGoogleActivity: ActivityComponentType<'SignInWithGoogleActivity'> = ({ params }) => {
    const { code } = params;
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default SignInWithGoogleActivity;
